/**
 * Slide content lookup by module and locale.
 * Static imports — total payload is small enough that code splitting isn't needed.
 */

import { cybersecuritySlides as cybersecurityEn } from './slides/en/cybersecurity';
import { aiLiteracySlides as aiLiteracyEn } from './slides/en/ai-literacy';
import { cybersecuritySlides as cybersecurityFr } from './slides/fr/cybersecurity';
import { aiLiteracySlides as aiLiteracyFr } from './slides/fr/ai-literacy';

const slideMap = {
  cybersecurity: { en: cybersecurityEn, fr: cybersecurityFr },
  aiLiteracy: { en: aiLiteracyEn, fr: aiLiteracyFr },
};

/**
 * Get slides for a training module in a given locale.
 * Falls back to English if the locale is unavailable.
 *
 * @param {'cybersecurity'|'aiLiteracy'} moduleKey
 * @param {string} locale — e.g. 'en', 'fr', 'en-US'
 * @returns {Array} slide objects
 */
export function getSlides(moduleKey, locale) {
  const lang = locale.substring(0, 2); // 'en-US' → 'en'
  const module = slideMap[moduleKey];
  if (!module) {
    throw new Error(`Unknown training module: ${moduleKey}`);
  }
  return module[lang] || module.en;
}
